export const breakpoints = {
  smDown: 640,
  mdDown: 832,
  lgDown: 1152,
  xlDown: 1440,
}
